import { render } from "./MyFooter.vue?vue&type=template&id=72018243&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"

import "./MyFooter.vue?vue&type=style&index=0&id=72018243&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72018243"]])

export default __exports__